import React from 'react';
import { getIntl } from '../../../../../utils/intl';
import { ContentStack } from '../../../../v2BaseComponents/Stack';
import Text from '../../../../v2BaseComponents/Text';
import { PromptActions } from '../../../../v2BaseComponents/Prompt';

const intl = getIntl('deleteConfirmationPromptContents', {
    confirmationMessage:
        'Are you sure you want to delete this connection?  This will remove all data associated with it.  It may take a few minutes for the data to be removed from this profile.',
    delete: 'Delete',
    cancel: 'Cancel',
});

export type DeleteConfirmationPromptContentsOwnProps = {
    medicalProfileId: string;
    healthSystemId: string | number;
    onClose: () => void;
    onDisconnect: () => void;
};

export type DeleteConfirmationPromptContentsProps = DeleteConfirmationPromptContentsOwnProps;

const DeleteConfirmationPromptContents: React.FC<DeleteConfirmationPromptContentsProps> = ({
    onClose,
    onDisconnect,
}) => {
    return (
        <ContentStack>
            <Text variant="body-1">{intl('confirmationMessage')}</Text>
            <PromptActions
                actions={[
                    {
                        title: intl('delete'),
                        variant: 'alert',
                        icon: 'Trash2',
                        onPress: () => {
                            onDisconnect();
                            onClose();
                        },
                    },
                    {
                        title: intl('cancel'),
                        onPress: onClose,
                        variant: 'secondary',
                        icon: 'X',
                    },
                ]}
            />
        </ContentStack>
    );
};

export default React.memo(DeleteConfirmationPromptContents);
